import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-reset',
  templateUrl: './confirmemail.component.html',
  styleUrls: ['./confirmemail.component.css']
})
export class ConfirmEmailComponent implements OnInit {
    resetkey: string;
    model: any = {};
    alert: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
        this.resetkey = this.route.snapshot.queryParams['key'] || '';

        this.confirm();
  }

  Alert(message: string) {
    this.alert = {
      message: message
    };
  }

  confirm() {
    this.router.navigate(['/resetpassword'], { queryParams: { key: this.resetkey }});
  }
}
